import { RouteObject } from "react-router";
import PageError from "@/routes/PageError";
import SigneringDone from "@/routes/home/SigneringDone";
import { CUSTOM_MSG } from "@/constants/messages";
import { ROUTES, UNAUTHORIZED_ROUTES } from "@/constants/routes";

export const authCallbackRoutes: RouteObject[] = [
  {
    path: "/Home/CompanyNotFound",
    id: ROUTES.loginCompanyNotFound.id,
    element: (
      <PageError
        msg={CUSTOM_MSG.companyNotFound}
        msgText={CUSTOM_MSG.companyNotFoundText}
      />
    ),
  },
  {
    path: "/Home/MitIdLoginFailure",
    id: ROUTES.midIdFailureRedicret.id,
    element: (
      <PageError
        msg={CUSTOM_MSG.mitIdLoginFailure}
        msgText={CUSTOM_MSG.mitIdLoginFailureText}
        redirectToLogin
      />
    ),
  },
  {
    path: "/Home/userNotFound",
    id: ROUTES.userNotFound.id,
    element: (
      <PageError
        msg={CUSTOM_MSG.userNotFound}
        msgText={CUSTOM_MSG.userNotFoundText}
        isLogout
      />
    ),
  },
  {
    path: "/Home/SigneringFailure",
    id: UNAUTHORIZED_ROUTES.signeringFailure.id,
    element: (
      <PageError
        msg={CUSTOM_MSG.mitIdLoginFailure}
        msgText={CUSTOM_MSG.mitIdLoginFailureText}
      />
    ),
  },
  {
    path: "/Home/SigneringDone",
    id: ROUTES.signeringDone.id,
    element: <SigneringDone />,
  },
  {
    path: "/Home/unauthorized",
    id: ROUTES.unauth.id,
    element: <PageError />,
  },
  {
    path: "/Home/InvalidToken",
    id: ROUTES.loginInvalidToken.id,
    element: <PageError msg={CUSTOM_MSG.invalidToken} />,
  },
];
